import type { TacticalEvent } from '../../components/dashboard/types';

export const toReplayEvents = (
  raw: any[],
  options?: { alreadyAscending?: boolean }
): TacticalEvent[] => {
  const list = options?.alreadyAscending ? raw : [...raw].reverse();
  return list.map((log: any) => {
    const spd = log.groundSpeed || 0;
    return {
      timestamp: log.timestamp || log.recordedAt || new Date().toISOString(),
      action: spd > 50 ? 'Enroute' : spd > 5 ? 'Taxiing' : 'Stationary',
      location: `${Number(log.lat).toFixed(4)}, ${Number(log.lng).toFixed(4)}`,
      altitude: log.altitude ?? 0,
      speed: spd,
      heading: log.heading || 0,
      type: spd > 50 ? 'FLIGHT' : 'GROUND',
      lat: log.lat,
      lng: log.lng,
      coordKey: `${Number(log.lat).toFixed(4)},${Number(log.lng).toFixed(4)}`,
    };
  });
};
